import { sva } from "@agapi/ui/panda/css";

export const cartItemStyles = sva({
  slots: ['item', 'container'],
  base: {
    item: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      gap: '4',
    },
    container: {
      width: {
        base: "containers.3xs",
      },
      flexShrink: 0
    }
  }
});
